import http from "./Http";

export default {
    getFluxoCaixaGerencialPivotGrid: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/pivotgrid', data)
    },
    getFluxoCaixaGerencialAnaliticoDataGrid: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/analiticoDataGrid', data)
    },
    getSituacaoEmpresaMestre: function() {
        return http.get("./api/financeiro/fluxocaixagerencial/situacaoEmpresaMestre");
    },
    postPerfilGerenciais: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/postPerfilGerenciais', data)
    },
    deletePerfilGerenciais: function (handle) {
        return http.post('./api/financeiro/fluxocaixagerencial/deletePerfilGerenciais/' + handle)
    },
    getPerfilGerenciais: function (handle) {
        return http.get('./api/financeiro/fluxocaixagerencial/getPerfilGerenciais/' + handle)
    },
    getFluxoCaixaGerencialSaldosBancarios: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/saldosBancarios', data)
    }
}
